// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"0f6c6fbd","352":"4516ad42","434":"b857453b","882":"a55e4b17"}[chunkId] + ".chunk.js";
};